module.exports = __webpack_public_path__ + "static/media/event-friends-combined-1-iphonex2.942c8b99.png";